import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SystemService } from 'src/app/base/services/system.service';
import { WebpayService } from '../../services/webpay.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-error-retorno',
  templateUrl: './error-retorno.component.html',
  styleUrls: ['./error-retorno.component.css']
})
export class ErrorRetornoComponent implements OnInit {
  ordenCompra: string;
  idSesion: string;
  parametros: any;

  constructor(private route: ActivatedRoute,
    private webpay: WebpayService,
    private systemService: SystemService,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.systemService.setLoading(true);
    this.parametros = JSON.parse(JSON.stringify(this.webpay.getQueryParams(window.location.href)));
    this.systemService.setLoading(false);
  }

  async volver() {
    this.systemService.setLoading(true);
    this.document.location.href = await this.webpay.setBotonVolver(this.parametros.uid, null);
    this.systemService.setLoading(false);
  }



}
